var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.content !== null)?_c('div',{staticClass:"content text-base dea-rich-text",class:{
        'md:text-base xl:text-lg': !_vm.useLargeFont,
        'md:text-lg lg:text-xl xl:text-2xl': _vm.useLargeFont,
    },domProps:{"innerHTML":_vm._s(_vm.content)}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }